export const PLACEMENT_POSITIONS = [
  'auto',
  'top',
  'right',
  'bottom',
  'left',
  'auto-start',
  'top-start',
  'right-start',
  'bottom-start',
  'left-start',
  'auto-end',
  'top-end',
  'right-end',
  'bottom-end',
  'left-end',
]
